import React from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'

const styles = theme => ({
  dialogContentRoot: {
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      overflowX: 'hidden',
    },
  },
})

const Onboarding = ({ classes, customer, customerPaymentMethod, subscription }) => {
  // This checks if onboarding should be shown
  const shouldShowOnboarding = customer && (!customerPaymentMethod || !subscription)

  return (
    <Dialog
      open={shouldShowOnboarding}
      maxWidth="md"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: 22,
          textAlign: 'center',
          padding: 20,
        },
      }}
    >
      <DialogTitle>
        <h2 style={{ margin: 0 }}>Complete Your Account Setup</h2>
      </DialogTitle>
      <DialogContent classes={{ root: classes.dialogContentRoot }}>
        {/* Onboarding content will go here */}
        <div>OnboardingNew Content</div>
      </DialogContent>
    </Dialog>
  )
}

const mapStateToProps = state => ({
  customer: state.paymentsManager.customer,
  customerPaymentMethod: state.paymentsManager.customer?.paymentMethods?.find(pm => pm.default),
  subscription: state.paymentsManager.subscription
})

export default connect(mapStateToProps)(withStyles(styles)(Onboarding))
